"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5956],{

/***/ 6638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GarageProfileHero": function() { return /* binding */ GarageProfileHero; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/js/react-splide.esm.js
var react_splide_esm = __webpack_require__(7677);
// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/css/splide.min.css
var splide_min = __webpack_require__(1826);
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileHeroSlider.tsx







var GarageProfileHeroSlider = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GarageProfileHeroSlider, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GarageProfileHeroSlider);
    function GarageProfileHeroSlider() {
        (0,_class_call_check/* default */.Z)(this, GarageProfileHeroSlider);
        return _super.apply(this, arguments);
    }
    var _proto = GarageProfileHeroSlider.prototype;
    _proto.render = function render() {
        var ref;
        var _props = this.props, images = _props.images, alt = _props.alt, id = _props.id, partner = _props.partner;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "garageListItem_slider -mx-6 lg:mx-0 col-span-full z-10",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_splide_esm/* Splide */.tv, {
                options: {
                    rewind: true,
                    height: 320,
                    breakpoints: {
                        767: {
                            height: 218
                        }
                    },
                    classes: {
                        arrows: "splide__arrows hidden md:block z-10"
                    },
                    type: "slide",
                    lazyLoad: "sequential",
                    preloadPages: 0,
                    perPage: 1,
                    arrows: images.length > 1,
                    drag: images.length > 1
                },
                children: [
                    images.length > 0 && images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: image.sizes && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                                className: "lg:rounded-l-md z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                    className: "lg:rounded-md w-full h-full object-cover",
                                    children: [
                                        image.sizes.filter(function(size) {
                                            return size.name.includes("profil");
                                        }).map(function(size, innerIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                media: "".concat(size.media),
                                                srcSet: "".concat("https://werkstatt.repareo.de/storage/" + size.path),
                                                width: "".concat(size.width),
                                                height: "".concat(size.height)
                                            }, id + "profileSlider" + innerIndex);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "lg:rounded-md w-full h-full object-cover",
                                            loading: index < 2 ? "eager" : "lazy",
                                            src: "https://werkstatt.repareo.de/storage/" + image.sizes[0].path,
                                            height: image.sizes[0].height,
                                            width: image.sizes[0].width,
                                            alt: index == 0 ? alt : ""
                                        })
                                    ]
                                })
                            }, id + "profileSlider" + index)
                        }, id + "profileSlider" + index);
                    }),
                    images.length === 0 || ((ref = images[0]) === null || ref === void 0 ? void 0 : ref.sizes) === null && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        className: "lg:rounded-l-md z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "rounded-md w-full h-full object-cover h-[218px] md:h-[320px]",
                            src: "https://werkstatt.repareo.de/" + partner.fallbackImage,
                            alt: "Werkstatt"
                        })
                    })
                ]
            })
        });
    };
    return GarageProfileHeroSlider;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileHero.tsx








var GarageProfileMap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(8085), __webpack_require__.e(135), __webpack_require__.e(7953), __webpack_require__.e(132)]).then(__webpack_require__.bind(__webpack_require__, 3221));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3221)
            ];
        }
    },
    ssr: false
});
var GarageProfileHero = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GarageProfileHero, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GarageProfileHero);
    function GarageProfileHero() {
        (0,_class_call_check/* default */.Z)(this, GarageProfileHero);
        return _super.apply(this, arguments);
    }
    var _proto = GarageProfileHero.prototype;
    _proto.render = function render() {
        var _props = this.props, garage = _props.garage, partner = _props.partner;
        var images = [
            {
                sizes: garage.cover_image_sizes
            }
        ].concat((0,_to_consumable_array/* default */.Z)(garage.images));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "garageProfile__hero col-span-full order-none lg:order-1 h-[218px] md:h-[320px]  grid grid-cols-2 gap-x-2 mb-6 lg:mb-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-2 lg:col-span-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileHeroSlider, {
                        images: garage ? images : [],
                        alt: garage ? garage.name : "",
                        id: garage.id,
                        partner: partner
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:block col-span-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-full rounded-r-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileMap, {
                            garage: garage
                        })
                    })
                })
            ]
        });
    };
    return GarageProfileHero;
}(react.PureComponent);


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);